import React, {useState, useEffect} from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";

export default function TextImage(props) {

	const height= window.innerHeight;  
	const width= window.innerWidth;

	useEffect(() => {
		const height= window.innerHeight;
		const width= window.innerWidth;
	}, []);

	if (props.isMobile) {
		return (
			<div
				style={{
					position: "relative",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					backgroundColor: "black",
					height: "100vh"
				}}
			>
				<LazyLoadImage
					src={props.src}
					width = {width}
					alt="description of image"
				>
				</LazyLoadImage>
			</div>
		)

	} else {
		return (
			<div
				style={{
					position: "relative",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					backgroundColor: "black",
					opacity: props.src? "1" : "0",
				}}
			>
				<LazyLoadImage
						src={props.src}
						height= {height}
						alt="description of image"
						 >
				</LazyLoadImage>
			</div>  
		)
	}
}